import { FC } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Image } from '@frontend/design-system';

interface Props {
  logoUrl?: string;
  onClick?: () => void;
}

export const CompanyLogo: FC<Props> = ({ logoUrl, onClick }) => {
  const { t } = useTranslation('digital-forms-experience');

  if (!logoUrl) return null;

  const clickable = Boolean(onClick);

  return (
    <div css={containerStyle(clickable)}>
      <Image src={logoUrl} alt={t('Company Logo')} onClick={onClick} animate={false} initial={false} />
    </div>
  );
};

export const containerStyle = (clickable: boolean) =>
  css({
    textAlign: 'center',
    marginBottom: theme.spacing(2),

    img: {
      maxHeight: 85,
      objectFit: 'contain',
      maxWidth: '100%',
      cursor: clickable ? 'pointer' : 'default',
    },
  });
